import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { userCan } from '../../helpers/Auth';

import { showModal } from '../../actions';

const FileStatus = ({
  file, share, handleChangeStatus, readOnly,
}) => {
  const intl = useIntl();

  const [editMode] = useState(false);

  const userCanEditFile = userCan('file.edit', file);
  const shareStatusCanChange = share && share.status_change;

  const getEditDisabled = () => {
    if (userCanEditFile) return false;
    if (shareStatusCanChange) return false;
    if (!userCanEditFile && !shareStatusCanChange) return true;
    if (!userCanEditFile && shareStatusCanChange) return false;
    return true;
  };

  const editDisabled = getEditDisabled();

  const handleShowStatusChange = () => {
    if (share && !share.status_change) return;
    if (!userCanEditFile || readOnly) return;

    handleChangeStatus([file]);
  };

  if (!file || (!file.status && share && !shareStatusCanChange)) {
    return null;
  }

  if (!file.status && !userCan('file.edit', file) && !share) {
    return null;
  }

  const styles = {
    backgroundColor: file.status ? file.status.color : '#bbb',
  };

  return (
    <span
      className={classnames(
        'editable-field',
        'editable-field-status',
        {
          'editable-field-editing': editMode,
          'editable-field-disabled': editDisabled,
          'editable-field-empty': !file.status,
          'editable-field-read-only': readOnly,
        },
      )}
      role="button"
      tabIndex={0}
      title={(editMode || editDisabled || readOnly) ? '' : intl.formatMessage({ defaultMessage: 'Click to edit' })}
      onKeyUp={() => handleShowStatusChange(file)}
      onClick={() => handleShowStatusChange(file)}
    >
      {file.status ? (
        <>
          <i
            className="file-status"
            style={styles}
            id={`FileStatusTooltip-${file.uuid}`}
          />
          <span>{file.status.name}</span>
        </>
      ) : (
        <>
          <i className="file-status" style={styles} id={`FileStatusTooltip-${file.uuid}`} />
          <span>{intl.formatMessage({ defaultMessage: 'No status' })}</span>
        </>
      )}
    </span>
  );
};

const mapStateToProps = state => ({
  statuses: state.Files.statuses,
  share: state.Shares.share,
});

const mapDispatchToProps = dispatch => ({
  handleChangeStatus: (files) => {
    dispatch(showModal('StatusModal', {
      className: 'status-change',
      files,
      backdrop: true,
      request: true,
    }));
  },
});

FileStatus.defaultProps = {
  share: null,
  readOnly: false,
};

FileStatus.propTypes = {
  handleChangeStatus: PropTypes.func.isRequired,
  file: PropTypes.object.isRequired,
  share: PropTypes.object,
  readOnly: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(FileStatus);
